import React, { useState } from "react";
import { useTransition, animated } from "react-spring";
import ProgressBar from "../../ProgressBar";
import { stepStyles } from "../formStyles";

export const DescribeYourCredit = ({ formData, setForm, navigation, step }) => {
  const [error, setError] = useState(false);
  const [isVisible] = useState(true);

  const transition = useTransition(isVisible, {
    from: { opacity: 0, transform: "translate3d(500px,0px,0)" },
    enter: { opacity: 1, transform: "translate3d(0,0px,0)" },
  });

  const credit = [
    { id: "Poor (620 and below)", title: "Poor (620 and below)" },
    { id: "Fair (630 - 689)", title: "Fair (630 - 689)" },
    { id: "Good (690 - 719)", title: "Good (690 - 719)" },
    { id: "Excellent (720 and above)", title: "Excellent (720 and above)" },
  ];

  const checkForNextStep = () => {
    if (formData.describeYourCredit === "") {
      setError(true);
      console.log("error");
    }
    if (formData.describeYourCredit !== "") {
      navigation.next();
      console.log("next");
    }
  };
  return (
    <div className={stepStyles.page}>
      <ProgressBar width={"90%"} />
      <div className={stepStyles.content}>
        {transition((style, item) =>
          item ? (
            <animated.div style={style} className={stepStyles.panel}>
              <h1 className={stepStyles.title}>How would you describe your credit?</h1>
              <div className="w-full">
                <label className="text-base font-medium text-gray-900"></label>
                <fieldset className="">
                  <legend className="sr-only">How would you describe your credit?</legend>
                  <div className={stepStyles.optionGroup}>
                    {credit.map((creditDescription) => (
                      <label key={creditDescription.id} className={stepStyles.optionRow}>
                        <input
                          onChange={setForm}
                          value={creditDescription.id}
                          id={creditDescription.id}
                          name="describeYourCredit"
                          type="radio"
                          className={stepStyles.radio}
                        />
                        <span className={stepStyles.label}>{creditDescription.title}</span>
                      </label>
                    ))}
                  </div>
                  {error ? <p className={stepStyles.error}>please fill out an answer</p> : null}
                </fieldset>
              </div>
            </animated.div>
          ) : null,
        )}
      </div>
      <div className={stepStyles.actionBar}>
        <div className={stepStyles.actionRow}>
          <div className="w-full md:w-auto">
            <button className={`${stepStyles.button} w-full`} onClick={() => checkForNextStep()}>
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
